import { createActions, createReducer } from "reduxsauce";
// import { NotificationManager } from "react-notifications";
import { urls, API_URI } from "../../api/urls";
import { apiConfig, getAccessToken } from "../../api/config";
import { NotificationManager } from "react-notifications";
import { IArticle, createArticle, createArticles } from "../dataMap/article";
import {
  ISnippet,
  ISnippetBackend,
  createSnippetBackend,
  createSnippet,
} from "../dataMap/snippet";
import { IEditor, createEditorBackend } from "../dataMap/editor";
import { IFolderBackend } from "../dataMap/folder";
import { IReportSource } from "../dataMap/report";
import { IUser } from "../dataMap/user";
import { ILabel } from "../dataMap/label";
import Axios from "axios";

/**Actions and types definitions **/
export const { Types, Creators } = createActions({
  addArticleRequest: null,
  addArticleSuccess: ["article", "status"],
  addArticleFailure: ["error"],
  updateArticleSuccess: ["article"],
  fetchArticlesRequest: null,
  fetchArticlesSuccess: ["articles", "ids"],
  fetchArticlesFailure: ["error"],
  getArticleSuccess: ["article"],
  shareArticleSuccess: ["message"],
  deleteArticleSuccess: ["articleId"],
  removeArticle: ["articleId"],
  addSnippetRequest: null,
  addSnippetSuccess: ["snippet", "position"],
  addSnippetsSuccess: ["snippets", "source"],
  deleteSnippetSuccess: ["snippet"],
  resetArticle: null,
  reorderSnippets: ["sourceIndex", "destinationIndex", "draggabledId"],
  setStatus: ["status", "statusType"],
  editorRequest: null,
  editorSuccess: ["editor"],
  editorFailure: ["error"],
  addSnippetToEditor: ["snippet", "editorContent"],
  addSnippetLabel: ["articleId", "snippetId", "label"],
  removeSnippetLabel: ["articleId", "snippetId", "label"],
  editSnippetsLabel: ["snippetId", "label"],
  setLabel: ["articleId", "label"],
  editLabel: ["label"],
  deleteLabel: ["labelId"],
});

interface IArticleState {
  status: string;
  editorStatus: string;
  article: IArticle;
  error: string;
  editorError: string;
  loading: boolean;
  loadingEditor: boolean;
  articles: IArticle[];
  share: boolean;
}

const INITIAL_STATE: IArticleState = {
  status: "",
  editorStatus: "",
  article: {
    id: null,
    name: "",
    updatedAt: "",
    createdAt: "",
    snippets: [],
    labels: [],
    editor: {
      id: null,
      title: "",
      subHeadline: "",
      content: "",
      snippets: [],
    },
    path: "",
    owner: {} as IUser,
  },
  error: "",
  editorError: "",
  loading: false,
  loadingEditor: false,
  articles: [],
  share: false,
};

export const addRequest = (state = INITIAL_STATE): IArticleState => {
  return {
    ...state,
    status: "saving",
    error: "",
  };
};
export const addSuccess = (
  state = INITIAL_STATE,
  action: { status: string; article: IArticle }
): IArticleState => {
  let articles = state.articles;
  const article = articles.find((article) => article.id === action.article.id);
  if (!article) {
    articles = [action.article].concat(state.articles);
  }
  return {
    ...state,
    // status: action.status,
    articles: articles,
    article: action.article,
    error: "",
  };
};
export const addFailure = (
  state = INITIAL_STATE,
  action: { error: string }
): IArticleState => {
  return {
    ...state,
    status: "",
    error: action.error,
  };
};
export const request = (state = INITIAL_STATE): IArticleState => {
  return {
    ...state,
    // article: INITIAL_STATE.article,
    status: "",
    loading: true,
    share: false,
  };
};
export const success = (
  state = INITIAL_STATE,
  action: { articles: IArticle[] }
): IArticleState => {
  return {
    ...state,
    loading: false,
    articles: action.articles,
    error: "",
  };
};
export const failure = (
  state = INITIAL_STATE,
  action: { error: string }
): IArticleState => {
  return {
    ...state,
    loading: false,
    articles: state.articles,
    error: action.error,
  };
};
export const updateSuccess = (
  state = INITIAL_STATE,
  action: { article: IArticle }
): IArticleState => {
  return {
    ...state,
    status: "updated",
    article: action.article,
    error: "",
  };
};
export const getSuccess = (
  state = INITIAL_STATE,
  action: { article: IArticle }
): IArticleState => {
  return {
    ...state,
    article: action.article,
    error: "",
  };
};

export const deleteSuccess = (
  state = INITIAL_STATE,
  action: { articleId: number }
): IArticleState => {
  return {
    ...state,
    articles: state.articles.filter(
      (article) => article.id !== action.articleId
    ),
  };
};

export const addSnippetRequest = (state = INITIAL_STATE): IArticleState => {
  return {
    ...state,
    status: "adding",
    error: "",
  };
};

export const addSnippetSucess = (
  state = INITIAL_STATE,
  action: { position: number; snippet: ISnippet }
): IArticleState => {
  const snippets = [...state.article.snippets];
  if (!snippets.some((snippet) => snippet.text === action.snippet.text)) {
    if (action.position || action.position === 0) {
      snippets.splice(action.position, 0, action.snippet);
    } else {
      snippets.push(action.snippet);
    }
  }
  return {
    ...state,
    status: "added",
    error: "",
    article: {
      ...state.article,
      snippets: snippets,
    },
  };
};

export const addSnippetsSucess = (
  state = INITIAL_STATE,
  action: { snippets: ISnippet[] }
): IArticleState => {
  const snippets = [...state.article.snippets];
  action.snippets.map((newSnippet) => {
    if (
      !snippets.some((snippet: ISnippet) => snippet.text === newSnippet.text)
    ) {
      snippets.push(newSnippet);
    }
    return newSnippet;
  });
  return {
    ...state,
    status: "added",
    article: {
      ...state.article,
      snippets: snippets,
    },
  };
};

export const deleteSnippetSuccess = (
  state = INITIAL_STATE,
  action: { snippet: ISnippet }
): IArticleState => {
  let snippets = state.article.snippets;
  if (action.snippet.id) {
    snippets = state.article.snippets.filter(
      (snippet) => snippet.id !== action.snippet.id
    );
  } else {
    snippets = state.article.snippets.filter(
      (snippet) => snippet.text !== action.snippet.text
    );
  }
  return {
    ...state,
    article: {
      ...state.article,
      snippets: snippets,
    },
  };
};
export const shareSuccess = (state = INITIAL_STATE): IArticleState => {
  return {
    ...state,
    share: true,
  };
};
export const reset = (state = INITIAL_STATE): IArticleState => {
  return INITIAL_STATE;
};

export const setStatus = (
  state = INITIAL_STATE,
  action: { status: string; statusType: string }
): IArticleState => {
  return {
    ...state,
    editorError: "",
    status: action.status,
    error: "",
  };
};

export const removeArticle = (
  state = INITIAL_STATE,
  action: { articleId: number }
): IArticleState => {
  return {
    ...state,
    articles: state.articles.filter(
      (article) => article.id !== action.articleId
    ),
  };
};

export const reorderSnippets = (
  state = INITIAL_STATE,
  action: {
    sourceIndex: number;
    destinationIndex: number;
  }
): IArticleState => {
  const snippets = [...state.article.snippets];
  snippets.splice(action.sourceIndex, 1);
  snippets.splice(
    action.destinationIndex,
    0,
    state.article.snippets[action.sourceIndex]
  );
  return {
    ...state,
    article: {
      ...state.article,
      snippets: snippets,
    },
  };
};

export const editorRequest = (state = INITIAL_STATE): IArticleState => {
  return {
    ...state,
    editorStatus: "saving",
    status: "",
    loadingEditor: true,
    editorError: "",
  };
};
export const editorSuccess = (
  state = INITIAL_STATE,
  action: { editor: IEditor }
): IArticleState => {
  let snippets = action.editor.snippets;
  if (snippets.length === 0) {
    if (state.article.editor && state.article.editor.snippets)
      snippets = action.editor.snippets;
  }
  return {
    ...state,
    status: "saved",
    loadingEditor: false,
    editorError: "",
  };
};
export const editorFailure = (
  state = INITIAL_STATE,
  action: { error: string }
): IArticleState => {
  return {
    ...state,
    editorStatus: "error",
    loadingEditor: false,
    editorError: action.error,
  };
};

export const addSnippetToEditor = (
  state = INITIAL_STATE,
  action: { editorContent: string; snippet: ISnippet }
): IArticleState => {
  const editor = state.article.editor;
  const snippets =
    state.article && state.article.editor && state.article.editor.snippets
      ? state.article.editor.snippets
      : [];
  return {
    ...state,
    article: {
      ...state.article,
      editor: {
        id: editor ? editor.id : null,
        title: editor ? editor.title : "",
        subHeadline: editor ? editor.subHeadline : "",
        content: editor.content,
        snippets: snippets.concat([action.snippet]),
      },
    },
  };
};

export const addSnippetLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel; articleId: number; snippetId: number }
): IArticleState => {
  const article = state.article;
  const snippets = [...article.snippets];
  const snippet = snippets.find(
    (snippet: ISnippet) => snippet.id === action.snippetId
  );
  if (snippet) {
    if (!snippet.labels.some((label: ILabel) => label.id === action.label.id)) {
      snippet.labels.push(action.label);
    }
  }
  return {
    ...state,
    error: "",
    article: { ...article, snippets },
    // articles: [...state.articles],
  };
};

export const removeSnippetLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel; articleId: number; snippetId: number }
): IArticleState => {
  const article = state.articles.find(
    (article: IArticle) => article.id === action.articleId
  );
  if (article) {
    const snippets = [...article.snippets];
    const snippet = snippets.find(
      (snippet: ISnippet) => snippet.id === action.snippetId
    );
    if (snippet) {
      const labelIndex = snippet.labels.findIndex(
        (label: ILabel) => label.id === action.label.id
      );
      if (labelIndex !== -1) {
        snippet.labels.splice(labelIndex, 1);
      }
    }
  }
  return {
    ...state,
    error: "",
    article: article || state.article,
    articles: [...state.articles],
  };
};

const setLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel; articleId: number }
): IArticleState => {
  const article = state.articles.find(
    (article: IArticle) => article.id === action.articleId
  );
  if (article) {
    article.labels.push(action.label);
    state.article.labels.push(action.label);
  }
  return {
    ...state,
    error: "",
    article: { ...state.article },
    articles: [...state.articles],
  };
};

const deleteLabel = (
  state = INITIAL_STATE,
  action: { labelId: number }
): IArticleState => {
  let article = state.articles.find(
    (article) => article.id === state.article.id
  );
  let snippets = state.article.snippets;
  if (article) {
    snippets = [...article.snippets];
    for (let i = 0; i < snippets.length; i++) {
      if (snippets[i].labels && snippets[i].labels.length) {
        const labelIndex = snippets[i].labels.findIndex(
          (label) => label.id === action.labelId
        );
        if (labelIndex !== -1) delete snippets[i].labels[labelIndex];
      }
    }
  } else {
    article = state.article;
  }

  return {
    ...state,
    articles: [...state.articles],
    article: {
      ...article,
      labels: article.labels.filter((label) => label.id !== action.labelId),
      snippets,
    },
  };
};

const editLabel = (
  state = INITIAL_STATE,
  action: { label: ILabel }
): IArticleState => {
  const article = state.articles.find(
    (article: IArticle) => article.id === state.article.id
  );
  if (article) {
    const labelIndex = article.labels.findIndex(
      (labelfilter) => labelfilter.id === action.label.id
    );
    if (labelIndex !== -1) {
      article.labels[labelIndex] = {
        ...article.labels[labelIndex],
        name: action.label.name,
        color: action.label.color,
      };
      article.snippets.map((snippet) => {
        if (snippet.labels && snippet.labels.length) {
          const labelIndex = snippet.labels.findIndex(
            (labelSnippet) => labelSnippet.id === action.label.id
          );
          if (labelIndex !== -1) {
            snippet.labels[labelIndex].name = action.label.name;
            snippet.labels[labelIndex].color = action.label.color;
          }
        }
        return snippet;
      });
    }
  }
  return {
    ...state,
    error: "",
    article: article || state.article,
    articles: [...state.articles],
  };
};

export const HANDLERS = {
  [Types.ADD_ARTICLE_REQUEST]: addRequest,
  [Types.ADD_ARTICLE_SUCCESS]: addSuccess,
  [Types.ADD_ARTICLE_FAILURE]: addFailure,
  [Types.UPDATE_ARTICLE_SUCCESS]: updateSuccess,
  [Types.FETCH_ARTICLES_REQUEST]: request,
  [Types.FETCH_ARTICLES_SUCCESS]: success,
  [Types.FETCH_ARTICLES_FAILURE]: failure,
  [Types.GET_ARTICLE_SUCCESS]: getSuccess,
  [Types.SHARE_ARTICLE_SUCCESS]: shareSuccess,
  [Types.DELETE_ARTICLE_SUCCESS]: deleteSuccess,
  [Types.REMOVE_ARTICLE]: removeArticle,
  [Types.ADD_SNIPPET_REQUEST]: addSnippetRequest,
  [Types.ADD_SNIPPET_SUCCESS]: addSnippetSucess,
  [Types.ADD_SNIPPETS_SUCCESS]: addSnippetsSucess,
  [Types.DELETE_SNIPPET_SUCCESS]: deleteSnippetSuccess,
  [Types.RESET_ARTICLE]: reset,
  [Types.REORDER_SNIPPETS]: reorderSnippets,
  [Types.SET_STATUS]: setStatus,
  [Types.EDITOR_REQUEST]: editorRequest,
  [Types.EDITOR_SUCCESS]: editorSuccess,
  [Types.EDITOR_FAILURE]: editorFailure,
  [Types.ADD_SNIPPET_TO_EDITOR]: addSnippetToEditor,
  [Types.ADD_SNIPPET_LABEL]: addSnippetLabel,
  [Types.REMOVE_SNIPPET_LABEL]: removeSnippetLabel,
  [Types.SET_LABEL]: setLabel,
  [Types.EDIT_LABEL]: editLabel,
  [Types.DELETE_LABEL]: deleteLabel,
};

export default createReducer(INITIAL_STATE, HANDLERS);

export const Actions = {
  ...Creators,
  newArticle: (dispatch, newArticle: IArticle, folderId: number) => {
    apiConfig
      .post(urls.ARTICLES, newArticle)
      .then(async (response) => {
        const article = response.data;
        if (folderId) {
          Creators.addFolderArticle(dispatch, folderId, article.id);
        }
        if (newArticle.snippets && newArticle.snippets.length > 0) {
          const snippets: ISnippetBackend[] = [];
          newArticle.snippets.forEach(function (snippet: ISnippet) {
            snippets.push(createSnippetBackend(snippet));
          });
          await apiConfig
            .post(`${API_URI}/articles/${article.id}/snippets/`, {
              snippets: snippets,
            })
            .catch((error) => {
              // NotificationManager.error("save snippets error", "Articles");
            });
        }
        await apiConfig
          .get(`${API_URI}/articles/${article.id}`)
          .then(async (response) => {
            dispatch(Creators.addArticleSuccess(createArticle(response.data)));
            // NotificationManager.success("Article created", "Articles");
          });
      })
      .catch((error) => {
        let errMsg =
          error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors[0]
            : "Error!!";
        //NotificationManager.error(errMsg, "Articles");
        dispatch(Creators.addArticleFailure(errMsg));
      });
  },

  updateArticle: (dispatch, article: IArticle) => {
    apiConfig
      .put(`${API_URI}/articles/${article.id}/`, article)
      .then(async (response) => {
        dispatch(Creators.updateArticleSuccess(createArticle(response.data)));
        //NotificationManager.success("Article updated", "Articles");
      })
      .catch((error) => {
        const errorMsg =
          error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors[0]
            : "Error!!";
        //NotificationManager.error(errorMsg, "Articles");
        dispatch(Creators.addArticleFailure(errorMsg));
      });
  },

  saveArticle: function (dispatch, article: IArticle, folderId: number) {
    dispatch(Creators.addArticleRequest());
    if (!(article && article.id)) {
      this.newArticle(dispatch, article, folderId);
    } else {
      this.updateArticle(dispatch, article);
    }
  },

  fetchArticleById: (dispatch, id: number) => {
    apiConfig
      .get(`${API_URI}/articles/${id}`)
      .then(async (response) => {
        const article = createArticle(response.data);
        dispatch(Creators.getArticleSuccess(article));
      })
      .catch((error) => {});
  },

  fetchArticles: (dispatch, order = "-updated_at", inFolder: boolean) => {
    dispatch(Creators.fetchArticlesRequest());
    apiConfig
      .get(`${API_URI}/articles?ordering=${order}`)
      .then(async (responseArticle) => {
        if (!inFolder) {
          apiConfig
            .get(`${API_URI}/folders?ordering=${order}`)
            .then(async (responsefolders) => {
              let articles = createArticles(responseArticle.data);
              await responsefolders.data.forEach((folder: IFolderBackend) => {
                folder.articles.forEach((folderArticle) => {
                  articles = articles.filter(
                    (filterArticle) => folderArticle.id !== filterArticle.id
                  );
                });
              });
              dispatch(Creators.fetchArticlesSuccess(articles));
            })
            .catch((error) => {
              dispatch(Creators.fetchArticlesFailure(error.message));
            });
        } else {
          dispatch(
            Creators.fetchArticlesSuccess(createArticles(responseArticle.data))
          );
        }
      })
      .catch((error) => {
        dispatch(Creators.fetchArticlesFailure(error.message));
      });
  },

  deleteArticle: (dispatch, id: number) => {
    apiConfig
      .delete(`${API_URI}/articles/${id}`)
      .then(async (article) => {
        dispatch(Creators.deleteArticleSuccess(id));
        NotificationManager.info(`deleted`, "Articles");
      })
      .catch((error) => {
        NotificationManager.error(`The Article can not be deleted`, "Articles");
      });
  },

  addSnippet: (
    dispatch,
    snippet: ISnippet,
    articleID: number,
    position: number
  ) => {
    dispatch(Creators.addSnippetRequest());
    if (articleID) {
      apiConfig
        .post(`${API_URI}/articles/${articleID}/snippets/`, {
          text: snippet.text,
          source: snippet.source.name,
          report_url: snippet.source.url,
        })
        .then(async (resp) => {
          dispatch(
            Creators.addSnippetSuccess(
              createSnippet({ ...resp.data }),
              position
            )
          );
          //NotificationManager.success("Snippet added", "Articles");
        })
        .catch((error) => {
          //NotificationManager.error(
          // "The snippet could not be added",
          // "Articles"
          // );
        });
    } else {
      dispatch(Creators.addSnippetSuccess(snippet, position));
    }
  },

  addSnippets: (
    dispatch,
    snippets: ISnippet[],
    source: IReportSource,
    articleID: number
  ) => {
    dispatch(Creators.addSnippetRequest());
    if (articleID) {
      snippets.map((snippet) => {
        return apiConfig
          .post(
            `${API_URI}/articles/${articleID}/snippets/`,
            createSnippetBackend({ ...snippet })
          )
          .then(async (resp) => {
            dispatch(
              Creators.addSnippetSuccess(
                createSnippet({ ...resp.data, source }) //iframeAccessible null
              )
            );
          })
          .catch((error) => {});
      });
    } else {
      dispatch(Creators.addSnippetsSuccess(snippets));
    }
  },

  deleteSnippet: (dispatch, snippet: ISnippet, articleId: number) => {
    if (articleId) {
      apiConfig
        .delete(`${API_URI}/articles/${articleId}/snippets/${snippet.id}`)
        .then(async (resp) => {
          dispatch(Creators.deleteSnippetSuccess(snippet));
          //NotificationManager.success("Snippet removed", "Articles");
        })
        .catch((error) => {
          // NotificationManager.error(
          //   "The snippet could not be deleted",
          //   "Articles"
          // );
        });
    } else {
      dispatch(Creators.deleteSnippetSuccess(snippet));
    }
  },

  shareArticle: (dispatch, email, id) => {
    apiConfig
      .post(`${API_URI}/articles/${id}/share/`, { email: email })
      .then(async (response) => {
        dispatch(Creators.shareArticleSuccess(response.data));
      })
      .catch((error) => {
        // NotificationManager.error(
        //   "The snippet could not be shared",
        //   "Articles"
        // );
      });
  },

  saveEditor: (dispatch, editor: IEditor, articleId: number) => {
    // dispatch(Creators.editorRequest());
    //update editor
    if (editor.id) {
      const editorData = createEditorBackend(editor, articleId);
      apiConfig
        .put(`${API_URI}/editor/${articleId}/`, editorData)
        .then(() => {
          // dispatch(
          //   Creators.editorSuccess({
          //     ...editor,
          //   })
          // );
        })
        .catch((error) => {
          dispatch(Creators.editorFailure(error));
        });
    }
  },

  getFilter: () => {
    return apiConfig.get(`${API_URI}/reports/filters/`);
  },

  setSnippetLabel: (
    dispatch,
    articleId: number | null,
    snippetId: number,
    label: ILabel
  ) => {
    apiConfig
      .patch(`${API_URI}/snippets/${snippetId}/labels/`, { label_id: label.id })
      .then(() => {
        dispatch(Creators.addSnippetLabel(articleId, snippetId, label));
      });
  },

  removeSnippetLabel: (
    dispatch,
    articleId: number | null,
    snippetId: number,
    label: ILabel
  ) => {
    apiConfig
      .delete(`${API_URI}/snippets/${snippetId}/labels/`, {
        data: { label_id: label.id },
      })
      .then(() => {
        dispatch(Creators.removeSnippetLabel(articleId, snippetId, label));
      });
  },

  exportToWord: (articleId: number | null) => {
    Axios.get(`${urls.ARTICLES}${articleId}/`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        Accept:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document ",
      },
    }).then((resp) => {
      console.log(resp);
      // dispatch(Creators.removeSnippetLabel(articleId, snippetId, label));
    });
  },
};
